import { render, staticRenderFns } from "./SidebarDashboardMenuStep.vue?vue&type=template&id=2554db21"
import script from "./SidebarDashboardMenuStep.vue?vue&type=script&lang=js"
export * from "./SidebarDashboardMenuStep.vue?vue&type=script&lang=js"
import style0 from "./SidebarDashboardMenuStep.vue?vue&type=style&index=0&id=2554db21&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports